import { signal } from "@angular/core";

export const isMobile = signal(null);
export const isDesktop = signal(null);
export const isTablet = signal(null);
